/* Mobile PDP controls reuse the existing Shopify product form and its variant/quantity state. */
if (!customElements.get('shop-mobile-buy')) {
  customElements.define('shop-mobile-buy', class ShopMobileBuy extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.primaryButton = this.productInfo?.querySelector('[id^="ProductSubmitButton-"]');
      this.button = this.querySelector('[data-shop-mobile-submit]');
      if (!this.productInfo || !this.primaryButton || !this.button) return;

      this.onClick = () => {
        if (!this.button.disabled) this.primaryButton.click();
      };
      this.button.addEventListener('click', this.onClick);

      this.syncButton = () => {
        this.button.disabled = this.primaryButton.disabled || this.primaryButton.getAttribute('aria-disabled') === 'true';
        const label = this.primaryButton.querySelector('span')?.textContent.trim();
        if (label && this.button.textContent.trim() !== label) this.button.textContent = label;
        this.updateVisibility?.();
      };
      this.syncButton();
      this.buttonMutation = new MutationObserver(this.syncButton);
      this.buttonMutation.observe(this.primaryButton, { attributes: true, childList: true, characterData: true, subtree: true });

      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.sectionVisible = true;
      this.primaryVisible = false;
      this.updateVisibility = () => {
        this.classList.toggle('is-visible', this.mobileQuery.matches && this.sectionVisible && !this.primaryVisible && !this.button.disabled);
      };
      this.onMediaChange = () => this.updateVisibility();
      this.mobileQuery.addEventListener('change', this.onMediaChange);
      this.sectionObserver = new IntersectionObserver(([entry]) => {
        this.sectionVisible = entry.isIntersecting;
        this.updateVisibility();
      });
      this.sectionObserver.observe(this.productInfo);
      this.primaryObserver = new IntersectionObserver(([entry]) => {
        this.primaryVisible = entry.isIntersecting;
        this.updateVisibility();
      }, { threshold: 0.1 });
      this.primaryObserver.observe(this.primaryButton);
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.buttonMutation?.disconnect();
      this.sectionObserver?.disconnect();
      this.primaryObserver?.disconnect();
      this.mobileQuery?.removeEventListener('change', this.onMediaChange);
    }
  });
}

function setupMobileDescriptions(root = document) {
  root.querySelectorAll('[data-shop-description-toggle]').forEach((button) => {
    if (button.dataset.shopDescriptionReady) return;
    button.dataset.shopDescriptionReady = 'true';
    const description = button.closest('.shop-pdp__description');
    const content = description?.querySelector('.shop-pdp__description-content');
    if (!description || !content) return;
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const update = () => {
      if (!mobileQuery.matches) {
        description.classList.remove('is-collapsible', 'is-expanded');
        button.hidden = true;
        button.setAttribute('aria-expanded', 'false');
        button.textContent = button.dataset.moreLabel;
        return;
      }
      description.classList.add('is-collapsible');
      button.hidden = !description.classList.contains('is-expanded') && content.scrollHeight <= content.clientHeight + 2;
    };
    button.addEventListener('click', () => {
      const expanded = description.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;
    });
    mobileQuery.addEventListener('change', update);
    update();
  });
}

document.addEventListener('DOMContentLoaded', () => setupMobileDescriptions());
document.addEventListener('product-info:loaded', (event) => setupMobileDescriptions(event.target));
